// extracted by mini-css-extract-plugin
export default {"noResults":"LinkTags__noResults___H7R4K","createNewLinkTagButtonWrapper":"LinkTags__createNewLinkTagButtonWrapper___QgP2q"};